/**
 * GMA-1623 (CompassCare Web 8/14) — Devices route container.
 *
 * Mounts the app-shell (WebShell) around the device-fleet screen (DevicesPage)
 * at /web/devices, wiring sidebar navigation to the router. This is the route
 * scaffolding: the live device feed (real fleet data from the API) is a
 * deliberate follow-up, so until then the page renders the demo fleet in demo
 * builds and its fail-safe empty table otherwise, inside a real, navigable
 * frame.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import WebShell from "../../components/web/WebShell";
import DevicesPage from "./DevicesPage";
import { DEMO_DATA_ENABLED, getDemoDeviceFleet } from "./demoData";

export default function WebDevicesRoute() {
  const navigate = useNavigate();
  // Capture one timestamp so demo-fleet generation and the `now` prop agree —
  // the last-seen freshness UI drifts if each call reads the clock separately.
  const now = Date.now();
  const devices = DEMO_DATA_ENABLED ? getDemoDeviceFleet(now) : [];
  return (
    <WebShell
      activeKey="devices"
      onNavigate={(section) => {
        if (section && section.path) navigate(section.path);
      }}
      title="Devices"
    >
      <DevicesPage devices={devices} now={now} />
    </WebShell>
  );
}
